import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=479de944&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"
import style0 from "../Style/comments.scss?vue&type=style&index=0&id=479de944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479de944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479de944')) {
      api.createRecord('479de944', component.options)
    } else {
      api.reload('479de944', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=479de944&scoped=true&", function () {
      api.rerender('479de944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/SprintPlanning/Components/Comments.vue"
export default component.exports